<template>
  <v-card flat>
    <v-data-table
      v-model="selected"
      :headers="tableHeaders"
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions,
      }"
      :items="query.data"
      :server-items-length="query.length"
      :options.sync="query.options"
      :loading.sync="query.loading"
      disable-sort
      item-key="_id"
      dense
    >
      <template v-slot:top>
        <v-row no-gutters class="pa-3 align-center">
          <span class="text-h6">User</span>

          <v-spacer></v-spacer>

          <v-btn
            small
            depressed
            class="rounded-xl"
            :disabled="!Object.keys(query.change).length"
            color="secondary"
            @click="discardChange()"
            >Cancel</v-btn
          >

          <v-btn
            small
            depressed
            class="rounded-xl ml-1"
            :disabled="!Object.keys(query.change).length"
            color="success"
            @click="saveChange()"
            >Save</v-btn
          >

          <!-- Filter Button -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                depressed
                class="rounded-xl cyan lighten-1 ml-1"
                dark
                v-bind="attrs"
                v-on="on"
                >Filter</v-btn
              >
            </template>

            <!-- Filter Menu -->
            <v-list dense>
              <v-list-item
                v-for="(item, i) in filterMenu"
                :key="i"
                @click="filter = item.filter"
                :disabled="item.disabled"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </template>

      <!-- Name -->
      <template v-slot:item.name="{ item: { name } }">
        {{ `${name.firstname} ${name.lastname}` }}
      </template>

      <!-- Store -->
      <template v-slot:item.store.storeName="{ item: { store } }">
        <template v-if="store">
          <a :href="`/stores/s/${store._id}?admin=true`" target="_blank">{{
            store.storeName
          }}</a>
        </template>
        <template v-else> - </template>
      </template>

      <!-- ID -->
      <template v-slot:item._id="{ item: { _id } }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"> {{ _id.slice(18) }} </span>
          </template>
          <span> {{ _id }}</span>
        </v-tooltip>
      </template>

      <!-- createdAt -->
      <template v-slot:item.createdAt="{ item: { createdAt } }">
        <span>
          {{
            new Date(createdAt).toLocaleString($langs.lang, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })
          }}</span
        >
      </template>

      <!-- lastSeen -->
      <template v-slot:item.lastSeen="{ item: { lastSeen } }">
        <span v-if="lastSeen">
          {{
            new Date(lastSeen).toLocaleString($langs.lang, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })
          }}</span
        >
        <span v-else class="font-weight-light text--disabled">
          Long time ago
        </span>
      </template>

      <!-- Role -->
      <template v-slot:item.type="{ item: { _id, type } }">
        <v-select
          v-if="query.change[_id]"
          dense
          solo
          flat
          hide-details
          style="max-width: 120px"
          :items="['admin', 'member']"
          v-model="query.change[_id]"
        >
          <template v-slot:append>
            <v-icon small>mdi-menu-down</v-icon>
          </template>
        </v-select>

        <div v-else class="d-flex align-center justify-space-between">
          {{ type }}
          <v-btn
            small
            icon
            @click="editUser(_id, type)"
            :disabled="query.loading"
          >
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
        </div>
      </template>

      <!-- Actions -->
      <!-- <template v-slot:item.actions="{ item: { _id, type } }">
        <v-btn
          small
          icon
          @click="editUser(_id, type)"
          :disabled="query.loading"
        >
          <v-icon small> mdi-pencil </v-icon>
        </v-btn>
      </template> -->
    </v-data-table>
    <div class="py-3 text-caption text--disabled">
      * Long time ago means the time before
      {{ new Date(query.maxLastSeen).toLocaleString($langs.lang) }}
    </div>
  </v-card>
</template>

<script>
import admin from "../../services/admin";
import api from "../../services/api";

export default {
  data() {
    return {
      tabs: [
        { title: "New shop" },
        { title: "New Order", disabled: true },
        { title: "Shop Ban", disabled: true },
        { title: "Order Ban" },
        { title: "User Ban", disabled: true },
      ],
      query: {
        data: [],
        change: {},
        length: 0,
        maxLastSeen: 0,
        options: {},
        loading: false,
      },
      // newshop, neworder, banshop, banorder, banuser
      itemsPerPageOptions: [10, 15, 30, 50],
      tableHeaders: [
        { text: "ID", value: "_id", cellClass: "px-2" },
        { text: "Name", value: "name", cellClass: "px-2" },
        { text: "Email", value: "email", cellClass: "px-2" },
        { text: "Store", value: "store.storeName", cellClass: "px-2" },
        { text: "Sign up", value: "createdAt", cellClass: "px-2" },
        { text: "Last Seen", value: "lastSeen", cellClass: "px-2" },
        {
          text: "Role",
          value: "type",
          width: 128,
          cellClass: "px-2",
        },
        // { text: "", value: "actions", cellClass: "px-2" },
      ],
      filter: {},
      filterMenu: [
        { title: "Default", filter: {} },
        { title: "Admin Only", filter: { type: "admin" } },
        { title: "Member Only", filter: { type: "member" } },
        { title: "User with Store", filter: { withstore: true } },
      ],
      selected: [],
    };
  },
  mounted() {},
  methods: {
    editUser(_id, value) {
      this.query.change = { ...this.query.change, [_id]: value };
    },
    discardChange() {
      this.query.change = {};
    },
    async fetchData() {
      this.query.loading = true;
      let { itemsPerPage, page } = this.query.options;
      const result = await admin.getUser({
        count: this.query.length == 0,
        size: itemsPerPage,
        page: page,
        ...this.filter,
      });
      this.query.loading = false;
      // console.log(result);

      if (result.success == false)
        return api.makeAlert("Server error", "error");
      this.query.data = result.users;
      this.query.maxLastSeen = result.maxLastSeen;
      if (result.amount) this.query.length = result.amount;
    },
    async saveChange() {
      let data = [];
      for (let key in this.query.change) {
        if (this.query.change[key] == "admin") {
          const {
            email,
            name: { firstname, lastname },
          } = this.query.data.find((u) => u._id == key);
          if (
            !confirm(
              `Set user's type to ADMIN!\n\nName: ${firstname} ${lastname}\nEmail: ${email}`
            )
          )
            continue;
        }
        data.push({ _id: key, type: this.query.change[key] });
      }

      console.log(`Save `, data);
      const { success, msg } = await admin.updateUserRole(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Saved update.", "success");

      await this.fetchData();
      this.discardChange();
    },
  },
  watch: {
    "query.options": function () {
      this.fetchData();
    },
    filter() {
      this.query.length = 0;
      this.query.options.page = 1;
      this.fetchData();
    },
  },
};
</script>

<style>
</style>